import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useInView } from "framer-motion";
import axios from "axios";
import API_BASE_URL from "../config/Config";
import { SectionTitle } from "./ui";
import AmbassadorCard from "./AmbassadorCard";

export default function PartnersSection() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/posts/?post_type=PARTNER`)
      .then((res) => {
        setPartners((res.data.data || []).slice(0, 8)); // Show only 8 on home
      })
      .catch((err) => {
        console.error("Ошибка при загрузке партнёров", err);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <section
      ref={ref}
      id="partners"
      className="relative py-20 md:py-28 bg-gradient-to-b from-white to-dark-50 overflow-hidden"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-primary-500/5 rounded-full blur-3xl -translate-x-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl translate-x-1/2" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          subtitle="Наши друзья"
          title="Партнёры"
          description="Компании и организации, которые разделяют наши ценности"
          className="mb-12"
        />

        <div className="mb-12">
          <AmbassadorCard />
        </div>

        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[...Array(8)].map((_, i) => (
              <div
                key={i}
                className="h-28 md:h-32 bg-dark-100/70 rounded-3xl animate-pulse"
              />
            ))}
          </div>
        ) : partners.length > 0 ? (
          <>
            {/* Partners grid */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-10 md:gap-x-10 md:gap-y-12">
              {partners.map((partner, index) => (
                <motion.div
                  key={partner.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.5, delay: index * 0.05 }}
                  className="group flex items-center justify-center"
                >
                  <img
                    src={partner.image_url}
                    alt={partner.title}
                    title={partner.title}
                    className="h-20 w-auto max-w-[180px] object-contain opacity-95 transition-all duration-300 group-hover:scale-105 group-hover:opacity-100 md:h-24 md:max-w-[210px] lg:h-28 lg:max-w-[230px]"
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/220x120?text=Logo";
                    }}
                  />
                </motion.div>
              ))}
            </div>

            {/* View all button */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={isInView ? { opacity: 1 } : {}}
              transition={{ delay: 0.5 }}
              className="text-center mt-10"
            >
              <Link
                to="/partners"
                className="inline-flex items-center gap-2 px-6 py-3 bg-dark-900 text-white font-medium rounded-xl hover:bg-dark-800 transition-colors"
              >
                Все партнёры
                <svg
                  className="w-4 h-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </Link>
            </motion.div>
          </>
        ) : (
          <p className="text-center text-dark-500">
            Информация о партнёрах скоро появится.
          </p>
        )}
      </div>
    </section>
  );
}
